import { Canvas } from "@dinahmoe/dmafjs-visual";

class LineTestWebGL extends Canvas {
  namespace = "visual:line-test-webgl";

  init(node, event) {
    super.init(node, event);
    node._isPaused = false;
  }

  pause(node) {
    node._isPaused = true;
  }

  resume(node) {
    node._isPaused = false;
  }

  destroy(node, event) {
    super.destroy(node, event);
  }
}

const lineTestWebGL = new LineTestWebGL();
export { LineTestWebGL, lineTestWebGL };
